let loader = document.querySelector(".collection-loader");
let filterOptions = document.querySelectorAll(".filter-option");
let priceFilters = document.querySelectorAll(".price-filter");
let sortSelect = document.querySelector(".sort-collection");
let cardView = document.querySelector(".card-view");
let maxPriceInput = document.querySelector(".price-filter.max");
let minPriceInput = document.querySelector(".price-filter.min");
let currentPage = window.location.search.includes("page")
  ? window.location.search.match(/page=(\d+)/)[0].match(/\d+/)[0]
  : "1";
let currentSort = window.location.search.includes("sort_by")
  ? window.location.search.substring(
      window.location.search.indexOf("sort_by=") + "sort_by=".length
    )
  : "";
let filterObjectArray = [];
let priceFilterArray = [];
let pendingFilterChanges = [];
let pendingPriceChanges = [];

filterOptions.forEach(function (el, ind) {
  el.addEventListener("change", function (e) {
    let filter = {
      type: el.dataset.param,
      value: el.dataset.value,
    };
    
    if (el.checked) {
      pendingFilterChanges.push(filter);
    } else {
      pendingFilterChanges = pendingFilterChanges.filter(
        (item) => item.value != filter.value
      );
    }
  });
});

(function getCurrentFilters() {
  let searchParams = window.location.search.replace("?", "");
  if (searchParams.includes("filter")) {
    let filterArray = searchParams.includes("&")
      ? searchParams.split("&")
      : [searchParams];
    filterArray.forEach(function (el, ind) {
      if (el.includes("filter") && !el.includes("price")) {
        let object = {
          type: el.split("=")[0],
          value: el.split("=")[1],
        };
        filterObjectArray.push(object);
        pendingFilterChanges.push(object);
      }
    });
  }
})();

function generateUrl() {
  let filterUrl = "";
  currentSort = currentSort.includes("&")
    ? currentSort.split("&")[0]
    : currentSort;
  
  const allFilters = [...filterObjectArray, ...pendingFilterChanges];
  
  allFilters.forEach(function (el, ind) {
    ind == 0
      ? (filterUrl += `?${el.type}=${el.value}`)
      : (filterUrl += `&${el.type}=${el.value}`);
  });
  
  const allPriceFilters = [...priceFilterArray, ...pendingPriceChanges];
  allPriceFilters.length > 1
    ? allPriceFilters.forEach(function (el, ind) {
        filterUrl.includes("?")
          ? (filterUrl += `&${el.type}=${el.value}`)
          : (filterUrl += `?${el.type}=${el.value}`);
      })
    : "";

  filterUrl.includes("?")
    ? (filterUrl += `&filter.v.availability=1&page=${currentPage}`)
    : (filterUrl += `?page=${currentPage}`);
  
  currentSort.trim().length > 1 ? (filterUrl += `&sort_by=${currentSort}`) : "";
  return filterUrl;
}

function updateUrl(url) {
  let currentPath = window.location.pathname;
  url.trim().length >= 1
    ? window.history.pushState("", "", url)
    : window.history.pushState("", "", currentPath);
  let fetchUrl = window.location.pathname + window.location.search;
  fetchUrl.includes("?")
    ? (fetchUrl += `&view=ajax`)
    : (fetchUrl += `?view=ajax`);
  return fetchUrl;
}

const updatePriceFilter = () => {
  pendingPriceChanges = [];
  priceFilters.forEach(function (el, ind) {
    let priceData = {
      type: el.dataset.value,
      value: el.value,
    };
    pendingPriceChanges.push(priceData);
  });
};

priceFilters.forEach(function (el, ind) {
  el.addEventListener("change", updatePriceFilter);
});


document.getElementById("apply-filter-btn").addEventListener('click', () => {
  currentPage = 1;
  filterObjectArray = [...pendingFilterChanges];
  priceFilterArray = [...pendingPriceChanges];
  
  const url = generateUrl();
  const fetchUrl = updateUrl(url);
  fetchProducts(fetchUrl);
  // close sidebar for small devices
  if (window.innerWidth < 990) {
    let filterWrap = document.querySelector(".filter-wrapper");
    let filterOverlay = document.querySelector(".filter-overlay");
    filterWrap.classList.toggle("active");
    filterOverlay.classList.toggle("active");
  }
});

function fetchProducts(url) {
  loader.classList.add("active");
  fetch(url)
    .then((response) => response.text())
    .then((data) => {      
      let parser = new DOMParser();
      let html = parser.parseFromString(data, "text/html");
      let productCardHtml = html.querySelector(
        ".collection-products-list-wrap"
      ).innerHTML;

      let newCount = html.querySelector("#product-count-col");
      if (newCount) {
        document.getElementById("product-count-col").innerHTML = newCount.innerHTML;
      }
      
      let activeFiltersHtml = html.querySelector(".active-filters").innerHTML;
      let paginateHtml = html.querySelector(".paginate-wrap").innerHTML;
      
      document.querySelector(".collection-products-list-wrap").innerHTML = productCardHtml;
      document.querySelector(".active-filters").innerHTML = activeFiltersHtml;
      // document.querySelector(".paginate-wrap").innerHTML = paginateHtml;
      
      loader.classList.remove("active");
      if (typeof disableUnavailableVariantCollection === 'function') {
        disableUnavailableVariantCollection();
      }
    })
    .catch((err) => console.error(err));
}

if (sortSelect) {
  sortSelect.addEventListener("change", function () {
    currentSort = this.value;
    currentPage = 1;
    
    filterObjectArray = [...pendingFilterChanges];
    priceFilterArray = [...pendingPriceChanges];
    
    const url = generateUrl();
    const fetchUrl = updateUrl(url);
    fetchProducts(fetchUrl);
  });
}

if(cardView) {
  cardView.addEventListener("change", function (e) {
    let rootStyle = document.querySelector(":root");
    rootStyle.style.setProperty("--collection-cards-row-desktop", this.value);
  });
}

var lowerSlider = document.querySelector("#lower"),
  upperSlider = document.querySelector("#upper"),
  lowerVal = parseInt(lowerSlider.value);
upperVal = parseInt(upperSlider.value);

upperSlider.oninput = function () {
  lowerVal = parseInt(lowerSlider.value);
  upperVal = parseInt(upperSlider.value);
  maxPriceInput.value = upperVal;
  minPriceInput.value = lowerVal;
  let event = new Event("change");
  maxPriceInput.dispatchEvent(event);
  minPriceInput.dispatchEvent(event);
  if (upperVal < lowerVal + 4) {
    lowerSlider.value = upperVal - 4;
    if (lowerVal == lowerSlider.min) {
      upperSlider.value = 4;
    }
  }
};

lowerSlider.oninput = function () {
  lowerVal = parseInt(lowerSlider.value);
  upperVal = parseInt(upperSlider.value);
  maxPriceInput.value = upperVal;
  minPriceInput.value = lowerVal;
  let event = new Event("change");
  maxPriceInput.dispatchEvent(event);
  minPriceInput.dispatchEvent(event);
  if (lowerVal > upperVal - 4) {
    upperSlider.value = lowerVal + 4;
    if (upperVal == upperSlider.max) {
      lowerSlider.value = parseInt(upperSlider.max) - 4;
    }
  }
};

const toggleFilterSidebar = (e) => {
  if(e.target.classList.contains("filter-button") || e.target.closest(".filter-button") || e.target.classList.contains("load-filters") || e.target.closest(".load-filters")) {
    let el = e.target;
    let filterWrap = el.closest(".filter-block-wrap");
    filterWrap.classList.toggle("open");
  }
}

document.addEventListener("click", toggleFilterSidebar);